
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { TokenInterceptor } from 'app/authorized-http.service';
import { UtilsService } from 'app/services/utils.service';
import { Http, Response } from '@angular/http';
import { FooterBarLinkResource } from '../../../models/FooterBarLinkResource';
import { HttpClient } from "@angular/common/http";
import { environment } from "app/baseUrl";

@Injectable()
export class FooterPagesService {

  constructor(private http: HttpClient, private httpa: TokenInterceptor, private utilsService: UtilsService) { }

  saveFooterPage(url, body): Observable<FooterBarLinkResource> {
    return this.http.post<FooterBarLinkResource>(environment['url'] + url, body)
  }

  getPageByIdService(url): Observable<FooterBarLinkResource> {
    return this.http.get<FooterBarLinkResource>(environment['url'] + url)
  }


}
